import getTenant from '../../../../requests/getTenant';
import { chessFieldsNames } from '../ChessForm/constants/chessFieldsNames';

export const validateNotEqualToInitVal =
  (initialValue, numberComparison = false) =>
  (_rule, value, callback) => {
    if (initialValue) {
      if (numberComparison) {
        const val = typeof value === 'string' ? value.replace(/,/g, '.') : value;
        
        if (Number(initialValue) === Number(val)) {
          callback(`Значение не изменено`);
        } else {
          callback();
        }
      } else {
        if (initialValue === value.trim()) {
          callback(`Значение не изменено`);
        } else {
          callback();
        }
      }
    } else {
      callback();
    }
  };

export const validateToZero = (_rule, value, callback) => {
  const reg = /^0+$/;

  if (reg.test(value)) {
    callback('Значение должно быть больше нуля');
  } else {
    callback();
  }
};

export const validateForGroundFloor = (form) => (_rule, value, callback) => {
  const isGroundFloor = form.getFieldValue(chessFieldsNames.isGroundFloor);
  const reg = /^0+$/;

  const isError = reg.test(value) && !isGroundFloor;

  if (isError) {
    callback(
      '0-й этаж считается цокольным. Активируйте поле "Цокольный этаж" или укажите другой этаж'
    );
  } else {
    callback();
  }
};

export const validateToFields =
  (form, fieldsName) => (_rule, _value, callback) => {
    const { getFieldsValue, validateFields } = form;
    const values = getFieldsValue(fieldsName);

    const isValue = fieldsName.find((name) => values[name]);

    if (isValue) {
      validateFields(fieldsName, { force: true });
    }

    callback();
  };

export const validateSum =
  (form, fieldsName, errMsg) => (_rule, value, callback) => {
    const { getFieldsValue } = form;

    let sum = 0;
    let completedLength = 0;
    const values = getFieldsValue(fieldsName);

    Object.values(values).forEach((val) => {
      let numValue;

      if (val && val.trim().length !== 0) {
        const replaceVal = val.replace(',', '.');

        numValue = Number(replaceVal);
      }

      if (!isNaN(numValue)) {
        sum += numValue;

        completedLength += 1;
      }
    });

    const isError =
      !isNaN(value) &&
      fieldsName.length === completedLength &&
      value !== +sum.toFixed(2) &&
      value !== 0;

    if (isError) {
      callback(errMsg);
    } else {
      callback();
    }
  };

export const validateToHasPhone = async (_rule, value, callback) => {
  if (value.length === 10) {
    const tenant = await getTenant(value);

    if (tenant) {
      callback('Житель с таким телефоном уже есть в системе');
    } else {
      callback();
    }
  } else {
    callback();
  }
};
